import _ from 'lodash'
export const MAX_NAME_CHARACTERS_LENGTH = 75
export type SUPPORTED_VALIDATION_KEYS = 'firstName' | 'lastName' | 'companyName'

const atLeastOneAlphaNumericPattern =
	/^.*[^(\x00-\x1f|\x7f|\x20-\x40|\x5b-\x60|\x7b-\x7e)].*$/
const specialCharactersRegexPattern =
	/^(?![.\s\S]*([\ufff9-\uffff\ud800-\udfff%\/<>]+|&#|:))[.\s\S]*$/

const validateAlphaNumericPattern = (input?: string): boolean => {
	if (input) {
		return atLeastOneAlphaNumericPattern.test(input)
	}
	return false
}

const validateSpecialCharactersPattern = (input?: string): boolean => {
	if (input) {
		return specialCharactersRegexPattern.test(input)
	}
	return false
}

const validateMaxLengthCharacters = (input?: string): boolean => {
	if (input) {
		return input.length <= MAX_NAME_CHARACTERS_LENGTH
	}
	return false
}

const validateFirstLastNameField = (input?: string) => {
	if (input && !_.isEmpty(input)) {
		if (!validateMaxLengthCharacters(input))
			return { isValid: false, errorKey: 'MAX_LENGTH_NAME_ERROR' }
		if (!validateSpecialCharactersPattern(input))
			return { isValid: false, errorKey: 'INVALID_SPECIAL_CHARS_ERROR' }
		if (!validateAlphaNumericPattern(input))
			return { isValid: false, errorKey: 'INVALID_NAME_ERROR' }
		// If contains number - then false
		if (/[0-9]/.test(input)) {
			return { isValid: false, errorKey: 'NO_NUMERIC_CHARACTERS_ERROR' }
		}
		return { isValid: true, errorKey: '' }
	}
	return { isValid: false, errorKey: '' }
}

const validateOtherNameField = (input?: string) => {
	if (input && !_.isEmpty(input)) {
		if (!validateMaxLengthCharacters(input))
			return { isValid: false, errorKey: 'MAX_LENGTH_NAME_ERROR' }
		if (!validateSpecialCharactersPattern(input))
			return { isValid: false, errorKey: 'INVALID_SPECIAL_CHARS_ERROR' }
		return { isValid: true, errorKey: '' }
	}
	return { isValid: false, errorKey: '' }
}

const validateInputField = (
	key: SUPPORTED_VALIDATION_KEYS,
	input?: string
): { isValid: boolean; errorKey: string } => {
	switch (key) {
		case 'firstName':
		case 'lastName':
			return validateFirstLastNameField(input)
		case 'companyName':
			return validateOtherNameField(input)
		default:
			return { isValid: true, errorKey: '' }
	}
}

export { validateInputField }
